export default {
  upload: {
    attachmentName: '附件名称',
    uploader: '上传人',
    uploadDate: '上传日期',
    delBtn: '删除',
    uploadBtn: '上传',
    noSelectDel: '请选择需要删除的数据',
    downLoadBtn: '批量下载',
    noSelectDownLoad: '请选择需要下载的数据',
    noSelectPrint: '请选择需要打印的数据',
    error: '当前限制选择 1 个文件，请删除后重新选择',
    printingData: '打印日期',
    printingName: '打印名称',
    printingSortNo: '打印次数',
  },
};
